import React from "react";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
export function SelectGroup({ children }) {
    const styles = useMultiStyleConfig("SelectGroup");
    return (React.createElement(chakra.div, { __css: styles["container"] },
        React.createElement(chakra.span, { __css: styles["label"] }, children)));
}
